module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/tag-premier.2407bac0.svg";